import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, Resolve, RouterStateSnapshot} from '@angular/router';
import {Action, MemoizedSelector, select, Store} from '@ngrx/store';
import {IAppState} from '@portal-ng/PNSCore/reducers';
import {LoadPNSRoles} from '@portal-ng/PNSUser/actions/PNSUser.action';
import * as fromUser from '@portal-ng/PNSUser/reducers';
import {take} from 'rxjs/operators';

@Injectable()
export class PNSRoleResolver implements Resolve<void> {

  constructor(private store: Store<IAppState>) {
  }

  entityName = 'Roles';
  selectMethod: MemoizedSelector<any, any> = fromUser.getRolesLoaded;
  selectAction: Action = new LoadPNSRoles();

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    this.store.pipe(select(this.selectMethod), take(1)).subscribe((hasLoaded) => {
      if (!hasLoaded) {
        this.store.dispatch(this.selectAction);
      } else {
        console.info(this.entityName + ' loading skipped, ' + this.entityName + ' are already loaded.');
      }
    });
  }

}
